import { ISetDurationOfAll } from '../interfaces/ISetDurationOfAll';

export default class SetDurationOfAll implements ISetDurationOfAll
{
  duration: number;
  mediaListID: string;
  mediaListName: string;
}
